'use client';
import React, { useState } from 'react';
import Pagination from './Pagination';
import { useTranslation } from 'react-i18next';
import ArticleModal from './article-modal';
export const DevUpdatesPageIndex = () => {
  const { t } = useTranslation();

  const updates = [
    {
      id: 1,
      img: '/assets/update15.png',
      img2: '/assets/coverMobile12.png',
      date: '26 February 2026',
      title: t('DevelopmentUpdate12'),
      description: t('dev_update12_1'),
      buttonText: t('readFullArticle'),
      description2: t('dev_update12_2'),
    },
    {
      id: 2,
      img: '/assets/update14.png',
      img2: '/assets/coverMobile11.png',
      date: '1 December 2025',
      title: t('DevelopmentUpdate11'),
      description: t('dev_update11_1'),
      buttonText: t('readFullArticle'),
      description2: t('dev_update11_2'),
    },
    {
      id: 3,
      img: '/assets/update13.png',
      img2: '/assets/coverMobile10.png',
      date: '10 November 2025',
      title: t('DevelopmentUpdate10'),
      description: t('dev_update10_1'),
      buttonText: t('readFullArticle'),
      description2: t('dev_update10_2'),
    },
    {
      id: 4,
      img: '/assets/update12.png',
      img2: '/assets/coverMobile9.png',
      date: '27 October 2025',
      title: t('DevelopmentUpdate9'),
      description: t('dev_update9_1'),
      buttonText: t('readFullArticle'),
      description2: t('dev_update9_2'),
    },
    {
      id: 5,
      img: '/assets/update11.png',
      img2: '/assets/coverMobile8.png',
      date: '13 October 2025',
      title: t('DevelopmentUpdate8'),
      description: t('dev_update8_1'),
      buttonText: t('readFullArticle'),
      description2: t('dev_update8_2'),
    },
    {
      id: 6,
      img: '/assets/update10.png',
      img2: '/assets/coverMobile7.png',
      date: '7 October 2025',
      title: t('DevelopmentUpdate7'),
      description: t('dev_update7_1'),
      buttonText: t('readFullArticle'),
      description2: t('dev_update7_2'),
    },
    {
      id: 7,
      img: '/assets/update9.png',
      img2: '/assets/coverMobile6.png',
      date: '1 October 2025',
      title: t('DevelopmentUpdate6'),
      description: t('dev_update6_1'),
      buttonText: t('readFullArticle'),
      description2: t('dev_update6_2'),
    },
    {
      id: 8,
      img: '/assets/update8.png',
      img2: '/assets/coverMobile5.png',
      date: '28 September 2025',
      title: t('DevelopmentUpdate5'),
      description: t('dev_update5_1'),
      buttonText: t('readFullArticle'),
      description2: t('dev_update5_2'),
    },
    {
      id: 9,
      img: '/assets/update7.png',
      img2: '/assets/coverMobile4.png',
      date: '23 September 2025',
      title: t('DevelopmentUpdate4'),
      description: t('dev_update4_1'),
      buttonText: t('readFullArticle'),
      description2: t('dev_update4_2'),
    },
    {
      id: 10,
      img: '/assets/update2.png',
      img2: '/assets/coverMobile2.png',
      date: '18 September 2025',
      title: t('DevelopmentUpdate3'),
      description: t('dev_update3_1'),
      buttonText: t('readFullArticle'),
      description2: t('dev_update3_2'),
    },
    {
      id: 11,
      img: '/assets/update2.png',
      img2: '/assets/coverMobile2.png',
      date: '9 September 2025',
      title: t('DevelopmentUpdate2'),
      description: t('dev_update2_1'),
      buttonText: t('readFullArticle'),
      description2: t('dev_update2_2'),
    },
    {
      id: 12,
      img: '/assets/Rectangle 5524.png',
      img2: '/assets/coverMobile.png',
      date: '5 September 2025',
      title: t('DevelopmentUpdate1'),
      description: t('dev_update1'),
      buttonText: t('readFullArticle'),
    },
  ];

  // ✅ Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3;

  const totalPages = Math.ceil(updates.length / itemsPerPage);

  // ✅ Slice data for current page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentUpdates = updates.slice(startIndex, startIndex + itemsPerPage);

  const [isOpen, setIsOpen] = useState(false);
  const [selectedUpdate, setSelectedUpdate] = useState(null);
  const handleOpenModal = (update: any) => {
    setSelectedUpdate(update);
    setIsOpen(true);
  };
  return (
    <div className="pt-[200px] pb-[100px] relative z-[1]">
      <img src="/assets/Mask group.png" className=" w-full h-auto object-cover top-0 absolute z-[-1]" alt="" />
      <img
        src="/assets/halfight.png"
        className="absolute right-0 lg:block hidden top-[500px] z-[-1] max-w-[255px] h-auto w-full"
        alt=""
      />
      <img
        src="/assets/alien9 1.svg"
        className="absolute left-[-14px] lg:block hidden bottom-[200px] z-[-1] max-w-[206px] h-auto w-full"
        alt=""
      />
      <img
        src="/assets/alien11 1.svg"
        className="absolute bottom-0 lg:block hidden max-w-[134.07020937094345px] h-auto largeScreen:bottom-[30%] right-10 lg:right-20"
        alt=""
      />
      <div className="max-w-[1384px] w-full mx-auto ">
        <div className="flex flex-col gap-[35px] ">
          <div className="flex flex-col gap-4 items-center px-4 ">
            <div className="flex flex-col  items-center lg:flex-row lg:gap-2">
              <h2 className="uppercase relative leading-none lg:leading-[136%] font-koulen text-[76px] lg:text-[90px] w-full font-normal text-white">
                Development
              </h2>
              <img src="/assets/Updates.png" className="max-w-[297px] max-lg:mt-[-40px] w-full" alt="" />
            </div>
            <p className="max-w-[768px] w-full mx-auto text-center font-medium text-lg leading-[140%] font-nunito">
              Explore our latest development releases and experience the exciting progress of our journey firsthand!
            </p>
          </div>
          <div className="grid pb-[9px] grid-cols-1 md:grid-cols-2 xl:grid-cols-3 lg:gap-x-[26px] gap-[26px] lg:gap-y-[19px]">
            {currentUpdates.map((update) => (
              <div
                key={update.id}
                className="bg-[#0487AB] pt-[14px] pb-[25px] px-4 rounded-[11.82px] border-[3.15px] border-[#003E58] shadow-desclaimerDesk"
              >
                <div className="border-[4px] h-full border-[#003E58] bg-[#005870] shadow-custom-inset py-[33px] pl-[22px] pr-[33px] flex flex-col gap-6">
                  {/* Image */}
                  <img src={update.img} className="max-w-full h-[244px] w-full" alt={update.title} />

                  <div className="max-w-[330px] w-full mx-auto">
                    {/* Date */}
                    <p className="text-lg text-white font-nunito font-medium">{update.date}</p>

                    {/* Title */}
                    <h2 className="shadowText text-[#003E57] koulen max-xxs:text-[30px] text-[34px] leading-[100%] py-3 font-normal">
                      {update.title.split('\n')[0]}
                    </h2>

                    {/* Description Wrapper */}
                    <div className="relative overflow-hidden mb-5 max-h-[7rem]">
                      <p className="text-lg leading-[120%] font-semibold font-nunito overflow-hidden [text-overflow:ellipsis] [display:-webkit-box] [-webkit-line-clamp:5] [-webkit-box-orient:vertical]">
                        {update.description}
                      </p>
                    </div>

                    {/* Button */}
                    <button
                      onClick={() => handleOpenModal(update)}
                      className="uppercase text-2xl font-normal bg-[#FFB3E8] rounded-[5.33px] border-[#EF53C0C0] border-[5.33px] shadow-desclBtn h-[62.66px] flex items-center justify-center w-full font-koulen text-[#003E57]"
                    >
                      {update.buttonText}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
        </div>
      </div>
      <ArticleModal isOpen={isOpen} setIsOpen={setIsOpen} data={selectedUpdate} />
    </div>
  );
};
